module.exports = __webpack_public_path__ + "static/img/ktcu-cs-competition-proposal.8a6a82f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ktcu-cs-competition-proposal.jpg
// module id = 9w/+
// module chunks = 0